import { createSelector } from 'reselect';

const selectBusinesses = (state: any) => state.business;


export const selectBusinessesCurrentItem = createSelector([selectBusinesses], (business) => business.current);

export const selectBusinessesListItems = createSelector([selectBusinesses], (business) => business.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectBusinessesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBusinessesQueryItems = createSelector([selectBusinesses], (business) => business.query);

export const selectBusinessesCreatedItem = createSelector([selectBusinesses], (business) => business.create);

export const selectBusinessesUpdatedItem = createSelector([selectBusinesses], (business) => business.update);

export const selectBusinessesReadItem = createSelector([selectBusinesses], (business) => business.read);

export const selectBusinessesDeletedItem = createSelector([selectBusinesses], (business) => business.delete);

export const selectBusinessesSearchedItems = createSelector([selectBusinesses], (business) => business.search);

export const selectBusinessesItemsCount = createSelector([selectBusinesses], (business) => business.count);

export const selectBusinessesItemsFilter = createSelector([selectBusinesses], (business) => business.filter);